// extracted by mini-css-extract-plugin
export default {"cls1":"SignupBanner-cls1_YVT","cls2":"SignupBanner-cls2__m_ SignupBanner-cls1_YVT"};